/**
 * Filter categories shown as tabs on the Portfolio page.
 * "all" is a special value meaning no filter applied.
 */
const portfolioCategories = [
  { value: "all", label: "All Projects" },
  { value: "residential", label: "Residential" },
  { value: "commercial", label: "Commercial" },
  { value: "renovation", label: "Renovation" },
];

export default portfolioCategories;